import React, { useState, useCallback, useContext } from 'react'
// import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'
import { motion, useViewportScroll, useTransform, useMotionTemplate } from "framer-motion"
import Bowtie from '../../graphics/bindle-how-desktop.svg'
import BowtieMobile from '../../graphics/bindle-how-mobile.svg'

import Container from '../global/Container'

import DisplayContext from '../../contexts/DisplayContext'

const HowComponent = ({ data, className }) => {

  const display = useContext(DisplayContext);

  const [elementTop, setElementTop] = useState(0);
  const { scrollY } = useViewportScroll()

  const _sectionScale = useTransform(scrollY, value => (value - elementTop) <= 1 ? 1 : 1 + ((value - elementTop) * 0.0001))

  const sectionScale = display == 'live' ? useMotionTemplate`scale(${_sectionScale})` : 'none'

  const measuredRef = useCallback(node => {
    if (node !== null) {
      setElementTop(node.getBoundingClientRect().top);
    }
  }, []);

  return (
    <div className={className} ref={measuredRef}>
      <span className="how">
        <div className="how-heading">
          <Container>
            <h1>{data.heading}</h1>
          </Container>
        </div>
        <Container>
          <motion.div
            className="foreground-mobile" 
            style={{ 
              transform: sectionScale
            }}>
              <BowtieMobile />
          </motion.div>
          <motion.div
            className="foreground" 
            style={{ 
              transform: sectionScale
            }}>
              <Bowtie/>
          </motion.div>
        </Container>
        <div className="how-body">
          <Container>
            {data.body}
          </Container>
        </div>
        
        <motion.div
          className="background"
          style={{ 
            transform: sectionScale,
            backgroundImage: `url(${
              data.background.childImageSharp
                ? data.background.childImageSharp.fluid.src
                : data.background
            })`
          }}
        />
      </span>
    </div>
  )
}

HowComponent.propTypes = {
  className: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
}

const How = styled(HowComponent)`
  ${tw`overflow-hidden bg-cover relative w-full`}
  padding: 8% 0;
  @media (max-width: 767px) {
    padding: 20% 0;
  }
  .background {
    ${tw`overflow-hidden bg-cover absolute w-full`}
    height: 100%;
    top: 0;
    background-position: center;
  }
  .foreground,
  .foreground-mobile {
    z-index: 3; 
    position: relative;
    width: 100%;
    height: auto;
    svg {
      width: 100%;
      height: auto;
    }
    @media (min-width: 768px) {
      display: block;
    }
  }
  .foreground {
    margin: -10% 0 5%;
    display: none;
    @media (min-width: 768px) {
      display: block;
    }
  }
  .background { 
    z-index: 1; 
    backface-visibility: hidden;
  }
  .foreground-mobile {
    max-width: 400px;
    margin: 2rem auto;
    display: block;
    @media (min-width: 768px) {
      display: none;
    }
  }

  .how-body {
    ${tw`w-full relative text-white text-2xl`}
    z-index: 2;
    @media (max-width: 1250px) {
      ${tw`text-lg`}
    }
    @media (max-width: 767px) {
      ${tw`text-base`}
    }
  }
  .how-heading {
    ${tw`w-full relative text-white`}
    z-index: 2;
    h1 {
      font-size: 140px;
      line-height: 90%;
      @media (max-width: 1250px) {
        font-size: 100px;
      }
      @media (max-width: 767px) {
        font-size: 70px;
      }
      @media (max-width: 479px) {
        font-size: 54px;
      }
    }
  }
`

export default How
